"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("./");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BadgeWrapper = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-badge'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  font-weight: bold;\n  font-size: 11px;\n  display: inline-block;\n  height: auto;\n  white-space: nowrap;\n  width: auto;\n  text-transform: uppercase;\n  background: ", ";\n  color: ", ";\n  position: relative;\n  border-radius: ", ";\n  line-height: 1;\n  overflow: hidden;\n  padding: 0px 8px;\n  text-overflow: ellipsis;\n  line-height: 1rem;\n  word-break: break-word;\n\n  ", "\n    ", "\n"])), function (props) {
  return props.color ? (0, _polished.transparentize)(0.85, props.color) : (0, _polished.transparentize)(0.85, props.theme.PrimaryGrey);
}, function (props) {
  return props.color ? (0, _polished.darken)(0.2, props.color) : (0, _polished.darken)(0.2, props.theme.PrimaryGrey);
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.spaceLeft && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "])), function (props) {
    return props.spaceLeft.length >= 3 ? props.spaceLeft : '10px';
  });
}, function (props) {
  return props.spaceRight && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        margin-right: ", ";\n      "])), function (props) {
    return props.spaceRight.length >= 3 ? props.spaceRight : '10px';
  });
});

var Badge = function Badge(props) {
  return /*#__PURE__*/_react["default"].createElement(BadgeWrapper, _extends({}, props, {
    color: props.color
  }), /*#__PURE__*/_react["default"].createElement(_.Text, {
    bold: true
  }, props.label));
};

exports.Badge = Badge;
Badge.defaultProps = {};
Badge.propTypes = {
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  spaceLeft: _propTypes["default"].any,
  spaceRight: _propTypes["default"].any
};